import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import classNames from 'classnames';

import imgPlaceholder from '../../../container/dashboard/img/image-placeholder.png';
import ErrorTop from '../../form/ErrorTop';

class QuoteFormSignupAStep1 extends React.Component {
  static defaultProps = {
    readOnly: false,
  };

  static propTypes = {
    readOnly: PropTypes.bool,
    product: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired,
    errors: PropTypes.object,
    touched: PropTypes.object,
    onChangeFormStep: PropTypes.func.isRequired,
  };

  render() {
    const { product, values, errors, touched, isValid, isSubmitting, readOnly } = this.props;

    function isFieldValid(field) {
      return (!!values[field] || touched[field]) && !errors[field];
    }

    return (
      <div className="form-step-content form-step-1-content">
        <div className="row">
          <div className="col-sm-8 landing-quote-big-heading">
            <strong>{this.props.company.name}</strong> has invited you to quote for&nbsp;
            <strong className="highlighted">{this.props.product.name}</strong> on the Importist
            Platform.
          </div>
          <div className="col-sm-4">
            <p>
              Importist is a free tool to help buyers and sellers manage their quotes and contacts
              more efficiently.
            </p>
            <p>
              Already have an account? &nbsp;
              <a href="/signin">Sign In</a>
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-8">
            <div className="landing-quote-image-and-volume-quotes">
              <img width={300} height={300} src={product.photosUrl[0] || imgPlaceholder} alt={''} />

              <div className="landing-quote-volume-quotes">
                <div className="volume-quotes-label">VOLUME QUOTES</div>
                {values.requiredQuantity.map((item, index) => {
                  const quantity = item.q;
                  return (
                    <div className="volume-quotes-value" key={index}>
                      {quantity} units
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <ErrorTop isSubmitting={isSubmitting} isValid={isValid} errors={errors} />

            <fieldset>
              <div
                className={classNames('form-group', {
                  'with-error': touched.companyName && errors.companyName,
                })}
              >
                <Field
                  name="companyName"
                  className="form-control big-input"
                  type="text"
                  disabled={readOnly}
                  placeholder="Company Name"
                />
                {touched.companyName &&
                  errors.companyName && <label className="error">{errors.companyName}</label>}
              </div>
              <div
                className={classNames('form-group', {
                  'with-error': touched.fullName && errors.fullName,
                })}
              >
                <Field
                  name="fullName"
                  className="form-control big-input"
                  type="text"
                  disabled={readOnly}
                  placeholder="Full Name"
                />
                {touched.fullName &&
                  errors.fullName && <label className="error">{errors.fullName}</label>}
              </div>
              <div
                className={classNames('form-group', {
                  'with-error': touched.email && errors.email,
                })}
              >
                <Field
                  name="email"
                  className="form-control big-input"
                  type="text"
                  disabled={readOnly}
                  placeholder="Email"
                />
                {touched.email && errors.email && <label className="error">{errors.email}</label>}
              </div>
              <div
                className={classNames('form-group', {
                  'with-error': touched.password && errors.password,
                })}
              >
                <Field
                  name="password"
                  className="form-control big-input"
                  type="password"
                  disabled={readOnly}
                  placeholder="Password"
                />
                {touched.password &&
                  errors.password && <label className="error">{errors.password}</label>}
              </div>
            </fieldset>

            <button
              className="btn blue-button wide-button big-button fullwidth-button uppercased-button"
              disabled={
                !isFieldValid('fullName') ||
                !isFieldValid('companyName') ||
                !isFieldValid('email') ||
                !isFieldValid('password')
              }
              type="button"
              onClick={() => {
                this.props.onChangeFormStep(2);
              }}
            >
              Start Quote
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default QuoteFormSignupAStep1;



// WEBPACK FOOTER //
// ./src/component/quote/QuoteFormSignupAStep1/index.js